module.exports = __webpack_public_path__ + "static/media/1019700.93fc7c88.jpg";